module.exports = __webpack_public_path__ + "assets/footer-cow-cap.9b9cb465.svg";